import { mapObjIndexed, invertObj } from 'ramda';
import { parameterize, CATEGORIES } from '@moda/portal-stanchions';

export { CATEGORIES };

export const CATEGORY_SLUGS = mapObjIndexed(category => parameterize(category), CATEGORIES);

export const CATEGORIES_BY_SLUG = invertObj(CATEGORY_SLUGS);

export type CategoryKey = keyof typeof CATEGORIES;

export type Category = (typeof CATEGORIES)[CategoryKey];
